import {  Divider, Grid, Typography } from "@mui/material";

export interface FormDividerProps {
  children?: React.ReactNode;
  className?: string;
  /** Space above this section's divider. Defaults to "48px" (unchanged for
   *  every existing caller); pass a smaller value to tighten one tab's
   *  section spacing without touching the other ~50 forms sharing this
   *  component. */
  pt?: string | number;
  /** Left inset. Defaults to "48px" (unchanged for every existing caller) —
   *  a fixed value that does NOT track the parent Grid container's own
   *  `spacing`, so it can drift out of alignment with sibling field items.
   *  This Grid is missing the `item` prop (a pre-existing bug — see the dev
   *  console warning "the prop `xs` of `Grid` can only be used together with
   *  the `item` prop"), which is presumably WHY this hardcoded `pl` exists
   *  at all; fixing that properly would change layout for the ~50 other
   *  forms sharing this component, so it is out of scope here. Pass the
   *  sibling fields' own measured left inset instead (e.g. "16px" under a
   *  `spacing={2}` container) to line this divider up with them exactly. */
  pl?: string | number;
  /** Overrides the global `.form-divider { margin-top: 30px }` rule
   *  (utils/global.css), which stacks with `pt` above rather than being
   *  replaced by it. Undefined by default (every existing caller keeps that
   *  30px); pass e.g. "0px" to cancel it exactly. Appends `!important`
   *  because a plain sx value is not reliably guaranteed to outrank a
   *  same-specificity global class rule by injection order alone. */
  mt?: string | number;
}

export const FormDivider: React.FC<React.PropsWithChildren<FormDividerProps>> = (
  props: FormDividerProps
) => {
  return (
    <Grid
      item
      className={props.className}
      xs={12}
      sx={{
        pl: props.pl ?? "48px",
        pt: props.pt ?? "48px",
        ...(props.mt !== undefined ? { mt: `${props.mt} !important` } : {}),
      }}
    >
      <Typography sx={{ paddingBottom: 1 ,color:"black" , fontWeight: "bold" }}>
        {props.children}
      </Typography>
      <Divider
        sx={{ borderColor: "black" }}
      />
    </Grid>
  );
};
